<template>
    <div class="container-fluid">
        <div class="row">
            <FormAnnualServiceFee  v-model:details="formAnnualServiceFee"/>
            <div v-for="(form, index) in formClouds" :key="index">
                <FormCloud @delete="deleteFormCloud(index)" @update="value => updateFormCloud(index, value)"/>
            </div>
        </div>
        <button class="btn btn-primary" type="button" @click="addFormCloud">+ Add new</button>
        <div class="row"></div>
        <button class="btn btn-success pull-right mb-4" type="button" @click="submitForm">บันทึก</button>
    </div>
</template>

<script setup>
import { ref, defineAsyncComponent } from 'vue'
import Swal from 'sweetalert2'
import { directus } from "@/services/directus"
import { createItems , updateItem , readItems } from "@directus/sdk"
import { updateFieldHistory } from "@/services/auto-history"

const FormAnnualServiceFee = defineAsyncComponent(() => import("@/components/theme/annual-service-fee/FormAnnualServiceFee.vue"))
const FormCloud = defineAsyncComponent(() => import("@/components/theme/annual-service-fee/FormCloud.vue"))

const formClouds = ref([{}])
const formAnnualServiceFee = ref([])

const addFormCloud = () => {
    formClouds.value.push({})
}

const deleteFormCloud = (index) => {
    formClouds.value.splice(index, 1)
}

const updateFormCloud = (index, value) => {
    formClouds.value[index] = value
}

async function submitForm() {
    const cloudsItems = [];
    const requiredServiceFeeFields = ["branch_name", "company_name", "store_name"];
    const requiredCloudsFields = ["clouds_name", "package", "actual_paid", "start_date", "due_date", "bill_number"];
    const hasEmptyServiceFeeValue = requiredServiceFeeFields.some(key =>
        formAnnualServiceFee.value[key] === "" || formAnnualServiceFee.value[key] === null || formAnnualServiceFee.value[key] === undefined
    );

    // ตรวจสอบว่ามี cloud ใดกรอกข้อมูลครบหรือไม่
    const hasCloudData = formClouds.value.some(cloud =>
        requiredCloudsFields.every(key =>
            cloud[key] !== "" && cloud[key] !== null && cloud[key] !== undefined
        )
    );

    if (hasEmptyServiceFeeValue && !hasCloudData) {
        errorAlert('กรุณากรอกข้อมูลให้ครบ!');
        return;
    }

    // สร้างเฉพาะ cloud ที่กรอกข้อมูลครบ
    for (let num = 0; num < formClouds.value.length; num++) {
        const cloud = formClouds.value[num];
        const isFilled = requiredCloudsFields.every(key =>
            cloud[key] !== "" && cloud[key] !== null && cloud[key] !== undefined
        );
        if (!isFilled) continue;

        const startDate = new Date(cloud.start_date);
        const dueDate = new Date(cloud.due_date);
        const now = new Date();

        let status = "not_specified";
        if (!isNaN(startDate) && !isNaN(dueDate)) {
            if (now < startDate) {
                status = "not_specified";
            } else if (now >= startDate && now <= dueDate) {
                const diffTime = dueDate - now;
                const diffDays = diffTime / (1000 * 60 * 60 * 24);
                status = diffDays <= 60 ? "near_expiry" : "in_use";
            } else if (now > dueDate) {
                status = "expired";
            }
        }

        const cloudsItem = {
            clouds_name: cloud.clouds_name || null,
            package: cloud.package || null,
            price: cloud.price || null,
            actual_paid: cloud.actual_paid || null,
            start_date: cloud.start_date || null,
            due_date: cloud.due_date || null,
            bill_number: cloud.bill_number || null,
            invoice_number: cloud.invoice_number || null,
            receipt_number: cloud.receipt_number || null,
            notes: cloud.notes || null,
            status: status,
        }
        cloudsItems.push(cloudsItem);
    }

    try {
        // ตรวจสอบ annual_service_fee ซ้ำ
        const existingFees = await directus.request(
            readItems('annual_service_fee', {
                filter: {
                    branch_name: { _eq: formAnnualServiceFee.value.branch_name },
                    company_name: { _eq: formAnnualServiceFee.value.company_name },
                    store_name: { _eq: formAnnualServiceFee.value.store_name }
                },
                limit: -1
            })
        );

        let clouds = [];
        let cloudsIds = [];
        if (cloudsItems.length > 0) {
            clouds = await directus.request(createItems('clouds', cloudsItems));
            cloudsIds = clouds.map(item => item.id);
            // updateFieldHistory('clouds', cloudsIds, 'history', 'เพิ้มข้อมูล');
        }

        if (existingFees && existingFees.length > 0) {
            // ถ้ามี annual_service_fee อยู่แล้ว ให้อัปเดต clouds_id
            const feeId = existingFees[0].id;
            const prevClouds = Array.isArray(existingFees[0].clouds_id) ? existingFees[0].clouds_id : [];
            const newCloudsIds = [...prevClouds, ...cloudsIds];
            await directus.request(updateItem('annual_service_fee', feeId, {
                clouds_id: newCloudsIds
            }));
        } else {
            // ถ้ายังไม่มี ให้สร้างใหม่
            await directus.request(createItems('annual_service_fee', {
                ...formAnnualServiceFee.value,
                clouds_id: cloudsIds,
            }));
        }
        successAlert();
    } catch (error) {
        errorAlert("อัพเดทข้อมูลไม่สำเร็จ!");
        console.error('Error creating/updating annual_service_fee:', error);
    }
}

function successAlert() {
    Swal.fire({
        icon: "success",
        title: "อัพเดทสำเร็จ!",
        confirmButtonColor: 'var(--theme-default)',
    }).then(() => {
        location.reload();
    });
}

function errorAlert(txt) {
    Swal.fire({
        icon: "error",
        title: txt,
        confirmButtonColor: 'var(--theme-default)',
    });
}
</script>